import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text/Text";
import { PointOfContact } from "src/core/drops/api/drops.api";

interface PointOfContactDisplayProps {
  contact: PointOfContact;
  mode: "preview" | "live";
}

const PointOfContactDisplay: React.ReactFCWithChildren<PointOfContactDisplayProps> = ({
  contact,
  mode
}) => (
  <PointOfContactDisplayWrapper
    direction="vertical"
    className={`contact contact-${mode}`}
  >
    <Text as="h2">
      {`${contact.contactName || "Contact support"}`}
    </Text>

    {!!contact.contactEmail && (
      <div>
        <Text weight="bold">
          Email:
          {" "}
        </Text>

        <Text>
          <a href={`mailto: ${contact.contactEmail}`}>
            {contact.contactEmail}
          </a>
        </Text>
      </div>
    )}

    {!!contact.contactNumber && (
      <div>
        <Text weight="bold">
          Phone:
          {" "}
        </Text>

        <Text>
          <a href={`tel: ${contact.contactNumber}`}>
            {contact.contactNumber}
          </a>
        </Text>
      </div>
    )}

    {!!contact.website && (
      <div>
        <Text weight="bold">
          Website:
          {" "}
        </Text>

        <Text>
          <a href={`${contact.website}`}>
            {contact.website}
          </a>
        </Text>
      </div>
    )}

    {!!contact.address && (
      <div className="address">
        <Text weight="bold">
          Address
        </Text>

        {contact.address.addressLine1 && (
          <Text>
            {contact.address.addressLine1}
          </Text>
        )}

        {contact.address.addressLine2 && (
          <Text>
            {contact.address.addressLine2}
          </Text>
        )}

        {contact.address.addressLine3 && (
          <Text>
            {contact.address.addressLine3}
          </Text>
        )}

        {contact.address.postcode && (
          <Text>
            {contact.address.city}
          </Text>
        )}

        {contact.address.city && (
          <Text>
            {contact.address.postcode}
          </Text>
        )}
      </div>
    )}
  </PointOfContactDisplayWrapper>
);

const PointOfContactDisplayWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.spacing.padding.lg};
    padding-bottom: ${theme.spacing.padding.lg};
    border-bottom: 1px solid ${theme.colors.lightGrey};

    &.contact-preview {
      border: 3px solid ${theme.colors.midGrey};
      padding: ${theme.spacing.padding.md};
      padding-top: calc(${theme.spacing.padding.md} + 10px);
      position: relative;

      &:after {
        content: "preview";
        position: absolute;
        font-size: 12px;
        top: 5px;
        right: 5px;
      }
    }

    .address {
      margin-top: ${theme.spacing.margins.md};
      span {
        display: block;
      }
    }
  `}
`;

export default PointOfContactDisplay;
